import { ID } from "../core/id";

export enum EBlockType {
  TEXT = "text",
  TEXTGROUP = "textrow",
  LINK = "link",
  DATETIMETEXT = "datetimetext",
  NOTIFICATION = "note",
  INPUT = "input",
  TAG = "tag",
  FAQ = "faq",
  UMAIN = "main_usluga",
  UFASTPAYMENT = "fast_payment",
  UCARD = "card",
  UHOW = "how",
  TWOTEXTS = "twotext",
  MIDDLETEXT = "middletext",
  BIGTEXT = "bigtext",
  SMALLTEXT = "smalltext",
}
export type BlockType =
  | EBlockType.TEXT
  | EBlockType.TEXTGROUP
  | EBlockType.LINK
  | EBlockType.DATETIMETEXT
  | EBlockType.NOTIFICATION
  | EBlockType.INPUT
  | EBlockType.TAG
  | EBlockType.FAQ
  | EBlockType.UMAIN
  | EBlockType.UFASTPAYMENT
  | EBlockType.UCARD
  | EBlockType.UHOW
  | EBlockType.TWOTEXTS
  | EBlockType.MIDDLETEXT
  | EBlockType.BIGTEXT
  | EBlockType.SMALLTEXT;

export type IBlock =
  | IBlockText
  | IBlockPayment
  | IBlockTextGroup
  | IBlockLink
  | IBlockNotification
  | IBlockInput
  | IBlockTextArea
  | IBlockCounter
  | IBlockFullCheckBox
  | IBlockInputTime
  | IBlockInputGender
  | IBlockTag;

export interface IBlockBase {
  id: string;
  type: BlockType;
}

export interface IBlockValueBase extends IBlockBase {
  value: any;
}

export interface IBlockText extends IBlockValueBase {}
export interface IBlockPayment extends IBlockBase {
  title: string;
}
export interface IBlockTextGroup extends IBlockBase {
  title: string | null;
  childrenId: string[] | null;
  isColumn: boolean;
}

export interface IBlockLink extends IBlockValueBase {
  title: string | null;
  blank: boolean;
}

export enum ENoteType {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success",
}

export interface IBlockNotification extends IBlockBase {
  title: string | null;
  text: string | null;
  status: ENoteType;
}

export enum EInputType {
  TEXT = "text",
  TEXTAREA = "textarea",
  COUNTER = "counter",
  FULLCHEACKBOX = "fullcheackbox",
  NUMBER = "number",
  TIME = "time",
  GENDER = "gender",
}

export interface IBlockInput extends IBlockBase {
  typeInput: EInputType;
  value: any;
  placeholder: string | null;
  labelOutside: string | null;
  required: boolean;
  error: string | null;
}

export interface IBlockTextArea extends IBlockInput {}

export interface IBlockInputNumber extends IBlockInput {}

export interface IBlockCounter extends IBlockInput {
  maxCount: number;
  minCount: number;
}

export interface IBlockFullCheckBox extends IBlockInput {
  messageLeft: string;
  messageRight: string;
}

export interface IBlockTag extends IBlockBase {
  value: any;
  text: string;
  default: boolean;
}

export interface IBlockInputTime extends IBlockInput {
  tags: IBlockTag[];
}

export interface IBlockInputGender extends IBlockInput {
  tags: IBlockTag[];
}

export interface BlocksGroup {
  id: string;
  product_id: ID | null;
  blocks: IBlock[];
}
